import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import "./Achievement.scss";
import AchievementCard from "../../components/achievementCard/AchievementCard";
import {achievementSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
export default function Achievement() {
  const {t} = useTranslation();
  const {isDark} = useContext(StyleContext);

  // Get translated achievement data
  const translatedAchievements =
    t("achievements.list", {returnObjects: true}) || [];

  if (!achievementSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="achievements">
        <div className="achievement-main-div">
          <div className="achievement-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading achievement-heading"
                  : "heading achievement-heading"
              }
            >
              {t("achievements.title")}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle achievement-subtitle"
                  : "subTitle achievement-subtitle"
              }
            >
              {t("achievements.subtitle")}
            </p>
          </div>
          <div className="achievement-cards-div">
            {translatedAchievements.map((translatedCard, i) => {
              // Get the original card data for static assets like images
              const originalCard = achievementSection.achievementsCards[i];

              return (
                <AchievementCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: translatedCard.title,
                    description: translatedCard.subtitle,
                    image: originalCard?.image,
                    imageAlt: originalCard?.imageAlt,
                    footer: originalCard?.footerLink || []
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
